module.exports = __webpack_public_path__ + "img/papelera.e7972e69.png";